import { Button } from './ui/Button';
import { Container } from './ui/Container';
import { Link } from 'react-router-dom';
import { hero, heroDemoSlot } from '../content/placeholders';
import { handleGetChromeExtension } from '../lib/ctaHandlers';
import { useAuth } from '../contexts/AuthContext';
import './Hero.css';

export function Hero() {
  const { user, loading, signInWithGoogle, isSupabaseConfigured } = useAuth();
  const showLoginCta = isSupabaseConfigured && !loading && !user;
  const showDashboardCta = isSupabaseConfigured && !loading && user;

  return (
    <section id="hero" className="hero" aria-labelledby="hero-heading">
      <Container className="hero__container">
        <div className="hero__content">
          <h1 id="hero-heading" className="hero__headline">
            {hero.headline}
          </h1>
          <p className="hero__support">
            {hero.support}
          </p>
          <div className="hero__ctas">
            {/* Primary CTA: replace handleGetChromeExtension with Stripe/auth flow when ready */}
            <Button
              type="button"
              variant="primary"
              size="lg"
              className="hero__cta hero__cta--primary"
              onClick={handleGetChromeExtension}
            >
              {hero.ctaPrimary}
            </Button>
            <Button as="a" href="#hero-demo" variant="secondary" size="lg" className="hero__cta hero__cta--secondary">
              {hero.ctaSecondary}
            </Button>
            {showLoginCta && (
              <span className="hero__cta-login-wrap">
                <Button
                  type="button"
                  variant="ghost"
                  size="lg"
                  className="hero__cta hero__cta--login"
                  onClick={() => signInWithGoogle()}
                >
                  <span className="hero__cta-login-icon" aria-hidden>
                    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                    </svg>
                  </span>
                  Log in with Google
                </Button>
              </span>
            )}
            {/* Dashboard: for logged-in users; manage subscription only through that page. */}
            {showDashboardCta && (
              <Button
                as={Link}
                to="/dashboard"
                variant="primary"
                size="lg"
                className="hero__cta hero__cta--upgrade"
                aria-label="Go to Dashboard"
              >
                Dashboard
              </Button>
            )}
          </div>
        </div>
        <div className="hero__mockup-wrap">
          <div className="hero__mockup" aria-hidden>
            <div className="hero__mockup-chrome">
              <span className="hero__mockup-dots" aria-hidden>
                <span /><span /><span />
              </span>
              <span className="hero__mockup-bar">DocSourced</span>
            </div>
            <div className="hero__mockup-content">
              <img
                src={hero.mockupImageUrl}
                alt={hero.mockupAlt}
                className="hero__mockup-img"
                width={640}
                height={400}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </Container>

      {/* Hero demo: YouTube embed when youtubeVideoId is set, else placeholder */}
      <div id="hero-demo" className="hero__demo-slot" aria-label="Product demo">
        <Container>
          <h2 className="hero__demo-title">{heroDemoSlot.title}</h2>
          <div className="hero__demo-inner">
            {heroDemoSlot.youtubeVideoId ? (
              <iframe
                src={`https://www.youtube.com/embed/${heroDemoSlot.youtubeVideoId}?rel=0`}
                title={heroDemoSlot.title}
                className="hero__demo-video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <div className="hero__demo-placeholder">
                <span className="hero__demo-play" aria-hidden>
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </span>
                <span className="hero__demo-placeholder-label">{heroDemoSlot.placeholderLabel}</span>
                <span className="hero__demo-placeholder-hint">{heroDemoSlot.placeholderHint}</span>
              </div>
            )}
          </div>
        </Container>
      </div>
    </section>
  );
}
